
export const facebookGroupOverhead = 'Studio PortalYogi';
export const facebookGroupHeader = 'Grupa Facebookowa';
export const facebookGroupParagraph = 'To nasze tajne miejsce do wymiany doświadczeń i wspierania się w domowej praktyce jogi. Codziennie Magdalena Bałdys i Kacper Matuszewski, nauczyciele jogi, są tam dla Ciebie dostępni.';
export const facebookGroupButton = 'Dołącz do grupy';
